import { Subsidiary } from '@coolblue-development/constants';
export function shouldRenderEnergyLabel({ subsidiary, bypassSubsidiaryCheck, }) {
    return bypassSubsidiaryCheck === true || subsidiary === Subsidiary.DE;
}
//# sourceMappingURL=shouldRenderEnergyLabel.js.map